import { Controller, Payload } from "../../config/controller";
import store, { ApplicationState } from "../../../core/store";
import { bindActionCreators, Dispatch } from "redux";

import { Paciente, initialValuePacienteState, PacienteState, PacienteActions, FilterPaciente } from "./paciente.model"
import { action } from "typesafe-actions";
import { call, put, take, takeLatest } from "redux-saga/effects";
import { ResultDb } from "../../services/db";
import { StatusAppState } from "../root/root.model";
import { Atendimento } from "../atendimento/atendimento.model";

export interface PacienteViewProps {
    pacienteState: PacienteState
    pacienteActions: PacienteActions
}


class PacienteController extends Controller<Paciente, PacienteState, PacienteActions> {
    constructor() {
        super(initialValuePacienteState.row.type, initialValuePacienteState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
            setFiltro: `@${this.moduloName}/SET_FILTRO`,
            readPacientesByAtendimento: `@${this.moduloName}/READ_PACIENTES_BY_ATENDIMENTO`,

        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
            setFiltro: (filtro: FilterPaciente) => action(this.actionsType.setFiltro, { filtro }),
            readPacientesByAtendimento: (row) => action(this.actionsType.readPacientesByAtendimento, { row })
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
            takeLatest(this.actionsType.setFiltro, this.setFiltroEffects.bind(this)),
            takeLatest(this.actionsType.readPacientesByAtendimento, this.readPacientesByAtendimentoEffects.bind(this)),
            takeLatest(this.actionsType.resultAfterEffcts, this.afterEffects.bind(this)),

        ]
    }

    private * afterEffects(actions: Payload) {
        console.log("afterEffects", actions);
        switch (actions.payload.actionType) {
            case this.actionsType.create:
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, msg: "Paciente adicionado a lista de espera", status: "ok", error: false, showAlert: true, showCadModal:false},
                    this.actionsType.resultAfterEffects
                ));
                break;
            case this.actionsType.setFiltro:
            case this.actionsType.readPacientesByAtendimento:
        }

    }

    private * readPacientesByAtendimentoEffects(actions: Payload) {
        try {
            let row: Atendimento = actions.payload.row;
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: true, status: "", msg: "Buscando pacientes aguardando atendimento..." },
                this.actionsType.readPacientesByAtendimento
            ));
            //buscar paciente com data da chegada igual a atual
            let dataIni = new Date();
            dataIni.setHours(0, 0, 0);
            let dtIni = dataIni.toISOString();
            let dataFim = new Date();
            dataFim.setHours(23, 59, 59);
            let dtFim = dataFim.toISOString()
            let resp: ResultDb<Paciente> = yield call(this.db.filter, {
                fieldsFilter: [
                    {
                        fieldName: "dt_hr_chegada", mangoQuery: "$and", fieldValue: [{
                            "$gte": dtIni,
                            "$lte": dtFim,
                        }]
                    },
                    { fieldName: "atendimento.medico._id", mangoQuery: "$eq", fieldValue: row.medico._id },
                    { fieldName: "situacao", mangoQuery: "$ne", fieldValue: "FINALIZADO" }
                ],
                indexName: "idx_pacientes_by_medico_id",
                sortBy: []
            })
            if (resp.status === "ok") {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loadingRows: false, status: "ok", msg: "Buscando concluida!", rows_paciente_atendimento: resp.rows as Paciente[], changeList: new Date().toISOString() },
                    this.actionsType.readPacientesByAtendimento
                ));
            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loadingRows: false, msg: resp.msg as string, status: "error", error: true, showAlert: true },
                    this.actionsType.readPacientesByAtendimento
                ))
            }
        } catch (error: any) {
            console.log("error readPacientesByAtendimento", error);
            let msg = "Ops, ocorreu uma falha em readPacientesByAtendimento, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.readPacientesByAtendimento
            ))

        }
    }

    private * setFiltroEffects(actions: Payload) {
        const filtro: FilterPaciente = actions.payload.filtro;
        console.log("chamou setFiltroEffects", filtro);
        try {
            const { dtIni, dtFim } = filtro

            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: true, status: "", msg: "Buscando pacientes do periodo..." },
                this.actionsType.setFiltro
            ));


            let resp: ResultDb<Paciente> = yield call(this.db.filter, {
                fieldsFilter: [
                    { fieldName: "type", mangoQuery: "$eq", fieldValue: this.moduloName },
                    {
                        fieldName: "dt_hr_chegada", mangoQuery: "$and", fieldValue: [{
                            "$gte": dtIni,
                            "$lte": dtFim,
                        }]
                    },

                ],
                indexName: "idx_pacientes_by_periodo"
            })
            if (resp.status === "ok") {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loadingRows:false, filtro: { ...this.state.filtro, ...filtro }, msg:"Busca de pacientes concluida!", rows: resp.rows as Paciente[], status: "ok", changeList: new Date().toISOString() },
                    this.actionsType.setFiltro
                ));

            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loadingRows:false, status:resp.status, msg:resp.msg as string, error:true, showAlert:true,  },
                    this.actionsType.setFiltro
                ));
            }
        } catch (error: any) {
            console.log("error setFiltroEffects", error);
            let msg = "Ops, ocorreu uma falha em setFiltroEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.setFiltro
            ))
        }
    }
}

export const pacienteController = new PacienteController()

export const mapStateToPacienteProps = (state: ApplicationState) => ({
    pacienteState: state.pacienteState,
})

export const mapDispatchToPacienteProps = (dispatch: Dispatch) => ({
    pacienteActions: bindActionCreators({ ...pacienteController.reducer.actions }, dispatch),
})

